import React from "react";
import PropTypes from "prop-types";
export function TwitterSmall({ color = "#55acee", width = 16, height = 16 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 21 16">
      <path
        fill={color}
        fillRule="evenodd"
        d="M20.533 2.505a6.258 6.258 0 0 1-.512.543c-.178.167-.37.334-.578.501-.208.167-.415.32-.623.46v.125c0 .028.007.069.022.125a.513.513 0 0 1 .022.125v.167c0 1.308-.267 2.652-.8 4.03a11.113 11.113 0 0 1-2.358 3.694c-1.039 1.085-2.321 1.983-3.849 2.693s-3.27 1.05-5.228 1.023a8.502 8.502 0 0 1-1.802-.105 23 23 0 0 1-1.713-.354 8.586 8.586 0 0 1-1.602-.564A72.134 72.134 0 0 1 0 14.238a.587.587 0 0 1 .267-.022c.088.014.178.021.267.021.089 0 .178.007.267.021a.587.587 0 0 0 .267-.02 5.72 5.72 0 0 0 1.468-.105 19.87 19.87 0 0 0 1.38-.334 5.784 5.784 0 0 0 1.29-.543c.414-.237.815-.466 1.2-.689a8.294 8.294 0 0 1-1.356-.271 3.692 3.692 0 0 1-1.18-.585 4.77 4.77 0 0 1-.911-.877 3.734 3.734 0 0 1-.601-1.148c.06.056.126.084.2.084.074 0 .148.007.223.02.073.015.14.015.2 0a.264.264 0 0 1 .178.022.814.814 0 0 1 .311-.021.704.704 0 0 0 .29-.021c.103-.028.2-.042.288-.042a.504.504 0 0 0 .268-.083 3.863 3.863 0 0 1-1.38-.502 5.055 5.055 0 0 1-1.09-.876 3.726 3.726 0 0 1-.734-1.17A3.68 3.68 0 0 1 .845 5.72v-.062c.149.09.304.167.468.208.162.042.326.09.489.146.163.056.326.091.49.105.162.014.333.035.51.062a7.315 7.315 0 0 1-.778-.667 3.886 3.886 0 0 1-.6-.794 4.144 4.144 0 0 1-.401-.918A3.738 3.738 0 0 1 .89 2.756c0-.14.014-.306.044-.501a4.108 4.108 0 0 1 .29-1.023 1.79 1.79 0 0 1 .244-.439 14.87 14.87 0 0 0 1.78 1.65c.652.514 1.357.946 2.113 1.294.756.348 1.55.633 2.38.856.831.223 1.692.348 2.581.376a1.25 1.25 0 0 0-.022-.21 7.218 7.218 0 0 0-.045-.229 1.108 1.108 0 0 1-.022-.23v-.208c0-.584.111-1.113.334-1.587.222-.473.527-.904.911-1.294.386-.39.846-.682 1.38-.877A5.693 5.693 0 0 1 14.548 0c.297.028.594.063.89.105.297.041.579.125.846.25s.519.265.756.417c.238.154.445.342.623.564.237-.083.475-.153.712-.208.238-.056.475-.126.712-.21a6.99 6.99 0 0 0 .667-.27c.208-.098.415-.216.623-.355-.06.278-.156.514-.29.71-.132.194-.273.396-.422.605a2.056 2.056 0 0 1-.534.522 8.937 8.937 0 0 0-.623.459c.208-.056.423-.097.646-.126.222-.027.437-.076.645-.146.207-.07.407-.132.6-.187.193-.056.393-.126.601-.21-.148.21-.304.39-.467.585z"
      />
    </svg>
  );
}
TwitterSmall.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export function Twitter({ color = "#333", width = 21, height = 21 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      class="bi bi-twitter-x"
      viewBox="0 0 16 16"
      id="Twitter-X--Streamline-Bootstrap"
      height={height}
      width={width}
    >
      <desc>Twitter X Streamline Icon: https://streamlinehq.com</desc>
      <path
        d="M12.6 0.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867 -5.07 -4.425 5.07H0.316l5.733 -6.57L0 0.75h5.063l3.495 4.633L12.601 0.75Zm-0.86 13.028h1.36L4.323 2.145H2.865z"
        stroke-width="1"
      />
    </svg>
  );
}
Twitter.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
